const selectors = {
  slideruleOpen: 'data-sliderule-open',
  slideruleClose: 'data-sliderule-close',
  sliderulePane: 'data-sliderule-pane',
  slideruleWrappper: '[data-sliderule]',
  focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
  dataAnimates: 'data-animates',
  children: `:scope > [data-animates], 
             :scope > * > [data-animates], 
             :scope > * > * >[data-animates],
             :scope > * > .sliderule-grid  > *`,
};

const classes = {
  isVisible: 'is-visible',
  isHiding: 'is-hiding',
  isHidden: 'is-hidden',
};

let sections = {};

class HeaderMobileSliderule {
  constructor(el) {
    this.sliderule = el;
    this.wrapper = el.closest(selectors.wrapper);
    this.key = this.sliderule.id;
    const btnSelector = `[${selectors.slideruleOpen}='${this.key}']`;
    const exitSelector = `[${selectors.slideruleClose}='${this.key}']`;
    this.trigger = document.querySelector(btnSelector);
    this.exit = document.querySelectorAll(exitSelector);
    this.pane = document.querySelector(`[${selectors.sliderulePane}]`);
    this.children = this.sliderule.querySelectorAll(selectors.children);

    this.trigger.setAttribute('aria-haspopup', true);
    this.trigger.setAttribute('aria-expanded', false);
    this.trigger.setAttribute('aria-controls', this.key);

    this.clickEvents();
    this.staggerChildAnimations();

    document.addEventListener('theme:sliderule:close', this.closeSliderule.bind(this));
  }

  clickEvents() {
    this.trigger.addEventListener(
      'click',
      function () {
        this.showSliderule();
      }.bind(this)
    );
    this.exit.forEach((element) => {
      element.addEventListener(
        'click',
        function () {
          this.hideSliderule();
        }.bind(this)
      );
    });
  }

  keyboardEvents() {
    this.trigger.addEventListener(
      'keyup',
      function (evt) {
        if (evt.which !== window.theme.keyboardKeys.SPACE) {
          return;
        }
        this.showSliderule();
      }.bind(this)
    );
    this.sliderule.addEventListener(
      'keyup',
      function (evt) {
        if (evt.which !== window.theme.keyboardKeys.ESCAPE) {
          return;
        }
        this.hideSliderule();
        this.buttons[0].focus();
      }.bind(this)
    );
  }

  staggerChildAnimations(reverse = false) {
    const childrenArr = reverse ? Array.prototype.slice.call(this.children).slice().reverse() : this.children;
    childrenArr.forEach((child, index) => {
      child.style.transitionDelay = `${index * 50 + 10}ms`;
    });
  }

  hideSliderule(close = false) {
    const paneStyle = window.getComputedStyle(this.pane);
    const paneTransitionDuration = parseFloat(paneStyle.getPropertyValue('transition-duration')) * 1000;
    const children = close ? this.pane.querySelectorAll(`.${classes.isVisible}`) : this.children;
    this.pane.style.setProperty('--sliderule-height', 'auto');
    this.staggerChildAnimations(true);
    this.pane.classList.add(classes.isHiding);
    this.sliderule.classList.add(classes.isHiding);
    this.sliderule.classList.remove(classes.isVisible);
    children.forEach((el) => {
      el.classList.remove(classes.isVisible);
    });
    const newPosition = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
    this.pane.setAttribute(selectors.sliderulePane, newPosition);
    const hidedSelector = close ? `[${selectors.dataAnimates}].${classes.isHidden}` : `[${selectors.dataAnimates}="${newPosition}"].${classes.isHidden}`;
    const hidedItems = this.pane.querySelectorAll(hidedSelector);
    if (hidedItems.length) {
      hidedItems.forEach((element) => {
        element.classList.remove(classes.isHidden);
      });
    }

    setTimeout(() => {
      this.pane.classList.remove(classes.isHiding);
      this.sliderule.classList.remove(classes.isHiding);
      this.staggerChildAnimations();
    }, paneTransitionDuration);
  }

  showSliderule() {
    this.pane.style.setProperty('--sliderule-height', 'auto');
    this.sliderule.classList.add(classes.isVisible);
    this.children.forEach((el) => {
      el.classList.add(classes.isVisible);
    });
    const oldPosition = parseInt(this.pane.dataset.sliderulePane, 10);
    const newPosition = oldPosition + 1;
    this.pane.setAttribute(selectors.sliderulePane, newPosition);
    const hidedItems = this.pane.querySelectorAll(`[${selectors.dataAnimates}="${oldPosition}"]`);
    if (hidedItems.length) {
      const hidedItemsTransition = parseFloat(window.getComputedStyle(hidedItems[0]).getPropertyValue('transition-duration')) * 1000;
      setTimeout(() => {
        hidedItems.forEach((element) => {
          element.classList.add(classes.isHidden);
        });
      }, hidedItemsTransition);
    }

    const newHeight = parseInt(this.trigger.nextElementSibling.offsetHeight);
    this.pane.style.setProperty('--sliderule-height', `${newHeight}px`);
  }

  closeSliderule() {
    if (this.pane && this.pane.hasAttribute(selectors.sliderulePane) && parseInt(this.pane.getAttribute(selectors.sliderulePane)) > 0) {
      this.hideSliderule(true);
      if (parseInt(this.pane.getAttribute(selectors.sliderulePane)) > 0) {
        this.pane.setAttribute(selectors.sliderulePane, 0);
      }
    }
  }
}

const headerMobileSliderule = {
  onLoad() {
    sections[this.id] = [];
    const els = this.container.querySelectorAll(selectors.slideruleWrappper);
    els.forEach((el) => {
      sections[this.id].push(new HeaderMobileSliderule(el));
    });
  },
};

export default headerMobileSliderule;
